export const isAppleDevice = (): boolean => {
	const userAgent = window.navigator.userAgent;
	return /iPad|iPhone|iPod|Macintosh/.test(userAgent);
};
